import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["endDateRecurringCompromise", "repeatCompromise", "inputDeleteOne", "inputDeleteAllFollowing", "inputDeleteAll", "deleteCompromises", "compromiseId", "compromiseRecurringId"]

  connect() {
    if(this.compromiseRecurringIdTarget.value != ""){
      var style = document.createElement("style")
      document.head.appendChild(style)
      style.sheet.insertRule(".xdsoft_datepicker {pointer-events: none}")
      style.sheet.insertRule(".xdsoft_datetimepicker {cursor: no-drop}")
    }
    else{
      var style = document.createElement("style")
      document.head.appendChild(style)
      style.sheet.insertRule(".xdsoft_datepicker {pointer-events: auto}")
      style.sheet.insertRule(".xdsoft_datetimepicker {cursor: auto}")
    }
  }
  
  addRequired() {
    if(this.repeatCompromiseTarget.checked){ 
      this.endDateRecurringCompromiseTarget.required = true
    }
    else{
      this.endDateRecurringCompromiseTarget.required = false
    }
  }

  enableButton() {
    this.deleteCompromisesTarget.removeAttribute("disabled")
    if(this.inputDeleteOneTarget.checked){
      this.deleteCompromisesTarget.href = `/compromises/${this.compromiseIdTarget.value}`
    }
    if(this.inputDeleteAllFollowingTarget.checked){
      this.deleteCompromisesTarget.href = `/compromises/destroy-all-following?compromise_id=${this.compromiseIdTarget.value}`
    }
    if(this.inputDeleteAllTarget.checked){
      this.deleteCompromisesTarget.href = `/compromises/destroy-all?compromise_id=${this.compromiseIdTarget.value}`
    }
  }
}
